var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-center atlas-loading-application no-step-section"},[_c('div',[_c('Loader'),_c('h4',{staticClass:"text-center"},[_vm._v(" Please wait while we load your most recent application data. ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }